(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Scroll to a card if the URL has a hash (e.g. coming back from a product page)
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Grill filter bar logic
  (function () {
    var active = new Set();

    function getCards() {
      return document.querySelectorAll('li[data-tags]');
    }

    function norm(s) {
      return (s || '').trim().toLowerCase();
    }

    function updateCounter(visible, total) {
      var counter = document.getElementById('grill-counter');
      if (counter) counter.textContent = 'Showing ' + visible + ' of ' + total + ' grills';
    }

    function applyFilters() {
      var cards = getCards();
      var total = cards.length;
      var visible = 0;
      var activeNorm = Array.from(active).map(norm);

      cards.forEach(function (card) {
        var tags = card.getAttribute('data-tags').split(',').map(norm);
        var show = activeNorm.length === 0 || activeNorm.every(function (f) {
          return tags.indexOf(f) !== -1;
        });

        if (show) {
          visible++;
          card.style.display = '';
          requestAnimationFrame(function () {
            card.style.transition = 'opacity 250ms ease, transform 250ms ease';
            card.style.opacity = '1';
            card.style.transform = 'scale(1)';
          });
        } else {
          card.style.transition = 'opacity 250ms ease, transform 250ms ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.95)';
          setTimeout(function () {
            if (card.style.opacity === '0') {
              card.style.display = 'none';
            }
          }, 260);
        }
      });

      updateCounter(visible, total);

      var clearBtn = document.getElementById('grill-clear');
      if (clearBtn) clearBtn.style.display = active.size > 0 ? '' : 'none';

      var emptyState = document.getElementById('grill-empty');
      if (emptyState) emptyState.style.display = visible === 0 && active.size > 0 ? '' : 'none';
    }

    function setChipVisualState(chip, isActive) {
      if (isActive) {
        chip.style.background = '#D97742';
        chip.style.color = '#16120F';
        chip.style.border = 'none';
        chip.setAttribute('aria-pressed', 'true');
      } else {
        chip.style.background = 'transparent';
        chip.style.color = '#F3EAE1';
        chip.style.border = '1.5px solid #F3EAE1';
        chip.setAttribute('aria-pressed', 'false');
      }
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.grill-chip');
      if (chip) {
        var f = chip.getAttribute('data-filter');
        if (active.has(f)) {
          active.delete(f);
          setChipVisualState(chip, false);
        } else {
          active.add(f);
          setChipVisualState(chip, true);
        }
        applyFilters();
        return;
      }

      var clearTrigger = e.target.closest('[data-clear-filters]');
      if (clearTrigger) {
        active.clear();
        document.querySelectorAll('.grill-chip').forEach(function (c) {
          setChipVisualState(c, false);
        });
        applyFilters();
      }
    });

    var observer = new MutationObserver(function (mutations) {
      var hasNewCard = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (
            (n.matches && n.matches('li[data-tags]')) ||
            (n.querySelector && n.querySelector('li[data-tags]'))
          );
        });
      });
      if (hasNewCard) applyFilters();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyFilters);
    } else {
      applyFilters();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
